import React from "react"
import DarkOverlay from "../DarkOverlay"

const SignupConfirmation = (props) => {
    return <DarkOverlay visible={props.visible} onClose={() => props.closeConfirmation()} className="email-signup-dark-overlay">
        <div className="email-signup-confirmation transform-fade-y">
            <div className="popup-head">
                <span className="title">Thanks</span>
                <div className="close-icon" onClick={() => props.closeConfirmation()}></div>
            </div>

            <div className="popup-body">
                <span className="text">Thank you for signing up to our newsletter.</span>
            </div>
        </div>
    </DarkOverlay>
}

export default SignupConfirmation